"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appWebsite = exports.paneMarginTop = exports.serviceFeeName = exports.appName = exports.panePadding = exports.displayTopBar = exports.roundedElementBorderRadius = void 0;
var roundedElementBorderRadius = 0;
exports.roundedElementBorderRadius = roundedElementBorderRadius;
var displayTopBar = true;
exports.displayTopBar = displayTopBar;
var panePadding = '2% 5% 5% 5%';
exports.panePadding = panePadding;
var appName = 'Busea';
exports.appName = appName;
var serviceFeeName = 'Busea service';
exports.serviceFeeName = serviceFeeName;
var paneMarginTop = '2%';
exports.paneMarginTop = paneMarginTop;
var appWebsite = 'https://busea.ec/';
exports.appWebsite = appWebsite;